export default function sendWsppProd(producto,direction){
    const urlProducto = `http://localhost:3000/productos${direction}/producto/${producto.id}`;
    let saltoLinea = "%0D%0A";
    // const link = "https://firebasestorage.googleapis.com/v0/b/miladetallesweb.appspot.com/o/products/alabastro/IMG-20200917-WA0001.jpg?alt=media&token=ea96c972-3900-48b5-918e-10aab3588a70"
    const numeroCelular = "999467372";
    const textoMensaje = `Hola Mila, quisiera comprar: ${saltoLinea} ${saltoLinea}-${producto.nombre} que esta
    S/. ${producto.precio}.00. ¿Sigue disponible? ${saltoLinea} ${saltoLinea} ${urlProducto} ${saltoLinea} ${saltoLinea}`;
    const wspLink = `https://api.whatsapp.com/send/?phone=51${numeroCelular}&text=${textoMensaje}&app_absent=0`;
    window.open(wspLink, "_blank");
}